import { render, staticRenderFns } from "./SettingsPanel.vue?vue&type=template&id=1cbf8338&"
import script from "./SettingsPanel.vue?vue&type=script&lang=ts&"
export * from "./SettingsPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/packages/axiom-design-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cbf8338')) {
      api.createRecord('1cbf8338', component.options)
    } else {
      api.reload('1cbf8338', component.options)
    }
    module.hot.accept("./SettingsPanel.vue?vue&type=template&id=1cbf8338&", function () {
      api.rerender('1cbf8338', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/04-web-components/powerbar/components/SettingsPanel/SettingsPanel.vue"
export default component.exports